import stringU from "./Strings";
export interface IStringUtils {
  replaceInvalidChars: (value: string) => string;
  lowerCaseExtension: (value: string) => string | undefined;
}
export interface ILessonDesignerUtils {
  stringU: IStringUtils;
}

export function simpleDebounce(delay: number) {
  let timer: number | null = null;
  return (fn: Function) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = window.setTimeout(() => {
      fn();
      timer = null;
    }, delay);
  };
}
const Utils: ILessonDesignerUtils = {
  stringU,
};

export function isNumber(value: any): value is number {
  return typeof value === "number";
}

export function getSVGPadding(strokeWidth: number, width: number, height: number) {
  const dimension = Math.min(width, height);
  return Math.max(strokeWidth, dimension * 0.05);
}

export function fallbackValues(...args: any[]) {
  return args.find((arg) => arg !== undefined);
}

export function objectOpacityFromRules(value = 1, visible = true, isInTime = true, isGhost = false) {
  /**
   * image is not in the timeline and the `ghost mode`
   * is activated opacity should be set to 25%
   */
  if (isGhost && !isInTime) {
    return 0.25;
  }

  /**
   * image is in the timeline and the `visible` mode is unticked
   * this changes the image in black and white, opacity should stay
   * at 100%
   */
  if (isInTime && !visible) {
    return 1;
  }

  /**
   * return value from the property panel or
   * default to 100%
   */
  return value ?? 1;
}

export const ensureInBounds = (
  x: number,
  y: number,
  width: number,
  height: number,
  initialWidth: number,
  initialHeight: number,
) => {
  // check if the viewbox is not over the svg
  if (x + width > initialWidth) {
    x = initialWidth - width;
  }
  // check if the viewbox is not over the svg
  if (y + height > initialHeight) {
    y = initialHeight - height;
  }
  // check if the viewbox is not over the svg
  if (x < 0) {
    x = 0;
  }
  // check if the viewbox is not over the svg
  if (y < 0) {
    y = 0;
  }
  return { x, y };
};

export function zoomRatioToViewBoxZoom(zoomRatio: number) {
  // the ration is fully zoomed out at 1, and the zooming is bigger as the number get smaller
  // we are inversing the ratio
  return inverseRatio(zoomRatio);
}

export function viewBoxZoomToZoomRatio(viewBoxZoom: number) {
  return inverseRatio(viewBoxZoom);
}

function inverseRatio(ratio: number) {
  return 1 - ratio;
}

export function getPageDimensions() {
  const pagePlayerArea = document.getElementById("pageplayerarea");
  const designBoxWrapper = document.getElementById("designBoxWrapper");
  const containerForContentArea = document.getElementById("containerForContentArea");
  const containerForApp = document.getElementById("containerForApp");

  let pagePlayerAreaRect: any;
  let designBoxWrapperRect: any;
  let containerForContentAreaRect: any;
  let containerForAppRect: any;

  if (pagePlayerArea) {
    pagePlayerAreaRect = pagePlayerArea.getBoundingClientRect();
  }

  if (designBoxWrapper) {
    designBoxWrapperRect = designBoxWrapper.getBoundingClientRect();
  }

  if (containerForContentArea) {
    containerForContentAreaRect = containerForContentArea.getBoundingClientRect();
  }

  if (containerForApp) {
    containerForAppRect = containerForApp.getBoundingClientRect();
  }

  return {
    pagePlayerArea: {
      pixelHeight: pagePlayerAreaRect.height,
      pixelWidth: pagePlayerAreaRect.width,
      pixelTop: pagePlayerAreaRect.top,
      pixelLeft: pagePlayerAreaRect.left,
      pixelRight: pagePlayerAreaRect.right,
      pixelBottom: pagePlayerAreaRect.bottom,
      pixelX: pagePlayerAreaRect.x,
      pixelY: pagePlayerAreaRect.y,
    },
    designBoxWrapper: {
      pixelHeight: designBoxWrapperRect.height,
      pixelWidth: designBoxWrapperRect.width,
      pixelTop: designBoxWrapperRect.top,
      pixelLeft: designBoxWrapperRect.left,
      pixelRight: designBoxWrapperRect.right,
      pixelBottom: designBoxWrapperRect.bottom,
      pixelX: designBoxWrapperRect.x,
      pixelY: designBoxWrapperRect.y,
    },
    containerForContentArea: {
      pixelHeight: containerForContentAreaRect.height,
      pixelWidth: containerForContentAreaRect.width,
      pixelTop: containerForContentAreaRect.top,
      pixelLeft: containerForContentAreaRect.left,
      pixelRight: containerForContentAreaRect.right,
      pixelBottom: containerForContentAreaRect.bottom,
      pixelX: containerForContentAreaRect.x,
      pixelY: containerForContentAreaRect.y,
    },
    containerForApp: {
      pixelHeight: containerForAppRect.height,
      pixelWidth: containerForAppRect.width,
      pixelTop: containerForAppRect.top,
      pixelLeft: containerForAppRect.left,
      pixelRight: containerForAppRect.right,
      pixelBottom: containerForAppRect.bottom,
      pixelX: containerForAppRect.x,
      pixelY: containerForAppRect.y,
    },
    version: 1,
  };
}

export default Utils;
export { stringU };
export { createLogger } from "./Logging";
export { parseStringToNumber, validation } from "./Validation";
export { conversion } from "./Conversion";
export const emptyArray: any[] = [];
